// services/api/products/GetProductsFiltered.ts
import axios from '@/utils/axios'

export default async function GetProductsFiltered({queryKey}: any) {
  // Extract all parameters from queryKey
  const queryParams = queryKey[1]
  
  // Build URLSearchParams with all existing parameters
  const params = new URLSearchParams({
    product_type: queryParams['product_type'] ?? '1',
    options: queryParams['options'] ?? '',
    categories: queryParams['categories'] ?? '',
    min_price: queryParams['minPrice'] ?? '',
    max_price: queryParams['maxPrice'] ?? '',
    sort: queryParams['sort'] ?? '',
    page: queryParams['page'] ?? '1',
    query: queryParams['query'] ?? '',
    count: queryParams['count'] ?? '5',
  })
  
  // Add country and currency if provided
  if (queryParams['country']) {
    params.append('country', queryParams['country'])
  }
  
  if (queryParams['currency']) {
    params.append('currency', queryParams['currency'])
  }
  
  const url = process.env.NEXT_PUBLIC_API_URL + '/products/get-products-filter?' + params.toString()
  
  // console.log('Fetching filtered products from:', url) // Optional: for debugging
  
  const {data} = await axios.get(url)
  return data
}